import React from "react";
import { useTranslation } from "next-i18next";

import Button from "components/Button";
import { LinkToPlaylist, type LinkToPlaylistProps } from "./LinkToPlaylist";

import styles from "../ListComponentHorizontal.module.scss";

export interface TSeeAllButton extends LinkToPlaylistProps {
  mode?: "link" | "button";
  linkLabel?: string;
}

export const SeeAllButton = ({
  mode = "link",
  linkLabel = "web_browse_content_see_all",
  ...props
}: TSeeAllButton) => {
  const { t } = useTranslation("translations");

  return (
    <LinkToPlaylist {...props}>
      {mode === "link" ? (
        <a className={styles.seeAll}>{t(linkLabel)}</a>
      ) : (
        <Button
          size="medium"
          variant="secondary"
          className={styles.plainSeeAll}
        >
          {t(linkLabel)}
        </Button>
      )}
    </LinkToPlaylist>
  );
};

export default SeeAllButton;
